import React from "react";
import SiteNavLink from "./SiteNavLink";
import { SubMenuType } from "./NavItem";

export interface SmallNavDropdownProps {
  className?: string;
  link: SubMenuType;
  id: string;
}

export const SmallNavDropdown = ({
  className,
  link,
  id,
}: SmallNavDropdownProps) => {
  return (
    <menu
      className={`absolute top-20 z-50 flex flex-col justify-between bg-white px-12 py-8 shadow ${
        className ? className : ""
      }`}
      id={id}
    >
      {link.links.map((childLink) => {
        if (childLink.type !== "link") {
          return <></>;
        } else {
          return (
            <li key={childLink.title}>
              <SiteNavLink href={childLink.href} title={childLink.title} />
            </li>
          );
        }
      })}
    </menu>
  );
};
